// ./src/utils/api/FeatureUsageService.ts
//
// WHICH PAGE-GATED FEATURES THIS ACCOUNT HAS DATA FOR (ROADMAP A2 item 1).
//
// ⚠⚠ NOT AN ENTITLEMENT. It answers "there are rows here", never "you may have this". The plan still
// decides what can be CREATED; this decides only whether a host may LOOK at what they already made
// after their plan lapsed — MONETIZATION §3.3.1, what was collected STAYS.
import { gql } from "@apollo/client";
import { OpResult } from "@sdflc/api-helpers";

import { ApiService } from "./ApiService";

const MY_FEATURE_USAGE_QUERY = gql`
  query myFeatureUsage {
    myFeatureUsage {
      code
      errors {
        name
        errors
      }
      data
    }
  }
`;

export class FeatureUsageService {
  /** The feature codes this account has at least one live row for. */
  static async mine(): Promise<OpResult> {
    return ApiService.executeQuery(MY_FEATURE_USAGE_QUERY, {});
  }
}
